export const appMList = (state) => state.appMList;

export const loadingAppM = (state) => state.loadingAppM;
